// import { APIGetUserLocations } from "../../src/api/stores.ts";
import { APIgetStores } from "../../src/api/settings.ts";

export const getBalanceMessage = (name,balance, inovce) => {
  const b = (balance ?? 0).toLocaleString();
  if(inovce)
    return `Dear ${name}, your current balance of chasis/invoice#: ${inovce} is ${b} USD.`;
  else
    return `Dear ${name}, your current balance is ${b} USD.`;
};

export const getBalanceMessage2 = (comp, name, vehicles = [], totalBalance, record = null, page =null) => {
console.log("record for view",record);
//'viewcust'
  let message = `📋 Balance Statement\n\nDear ${name},`
  
  const currency = getCurrencySymbol();
  let filteredVehicles;
  if(page == "viewcust")
  {
    filteredVehicles =  (vehicles ?? [])
  }
  else
  {
    filteredVehicles =  (vehicles ?? []).filter(v => {
      const grossTotal = v.grossTotal ?? 0;
      const totalPaid = v.totalPaid ?? 0;
      return grossTotal - totalPaid > 0;
    });
  }


  if (filteredVehicles && filteredVehicles?.length>0) {
     message += `\nHere is the summary of your vehicle payments:\n\n`;
    filteredVehicles.forEach((v) => {
      if (!v.products || v.products.length === 0) return;

      const product = v.products[0];
      const grossTotalVal = v.grossTotal ?? 0;
      const totalPaidVal = v.totalPaid ?? 0;
      const balanceVal = grossTotalVal - totalPaidVal;

      const grossTotal = `${currency}${grossTotalVal.toLocaleString()}`;
      const totalPaid = `${currency}${totalPaidVal.toLocaleString()}`;
      const balance = `${currency}${balanceVal.toLocaleString()}`;
     
      message += `🚗 ${product.name || "Vehicle"}\n`;
      message += `🔧 Chassis: ${product.chassisNumber || "-"}\n`;
      if (v.departureDate) message += `🛫 Departure: ${v.departureDate}\n`;
      message += `💵 Price: ${grossTotal}\n`;
      message += `✅ Received: ${totalPaid}\n`;
      message += `💰 Balance: ${balance}\n`;
      message += `___________________________\n`;

   
    });
      message += `\n🔢 Total Remaining Balance: ${currency}${totalBalance.toLocaleString()}\n\n`;
      message += `Please let us know if you have any questions or need further clarification.\n\n`;
      message += `Best regards,\n`;
      message += comp;//`Pak Nippon Corporation, Japan`;
  } 
  else if (record) {
    const product = record;
    const grossTotalVal = product.grossTotal ?? 0;
    const totalPaidVal = product.paidAmounts ?? 0;
    const balanceVal = grossTotalVal - totalPaidVal;

    const grossTotal = `${currency}${grossTotalVal.toLocaleString()}`;
    const totalPaid = `${currency}${totalPaidVal.toLocaleString()}`;
    const balance = `${currency}${balanceVal.toLocaleString()}`;
    message += `\nHere is the summary of your vehicle payments:\n\n`;
    message += `🚗 ${product.productName || "Vehicle"}\n`;
    message += `🔧 Chassis: ${product.chassisNumbers || "-"}\n`;
    if (product.departureDate) message += `🛫 Departure: ${product.departureDate}\n`;
    message += `💵 Price: ${grossTotal}\n`;
    message += `✅ Received: ${totalPaid}\n`;
    message += `💰 Balance: ${balance}\n`;
    message += `___________________________\n`;

    message += `\n🔢 Remaining Balance: ${currency}${totalBalance.toLocaleString()}\n\n`;
    message += `Please let us know if you have any questions or need further clarification.\n\n`;
    message += `Best regards,\n`;
    message += comp;//`Pak Nippon Corporation, Japan`;
  } 
  else {
 
    message += `\n🔢 Balance: ${currency}${(totalBalance?totalBalance:0).toLocaleString()}\n\n`;
    message += `Please let us know if you have any questions or need further clarification.\n\n`;
    message += `Best regards,\n`;
    message += comp;//`Pak Nippon Corporation, Japan`;

  }

  return message;
};



export const dateFormatter = (date,local) => {//ar or en
    console.log('dateFormatter',date);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const formattedDate = new Intl.DateTimeFormat(local, options).format(date);
    return formattedDate;
}

export const dateFormatter2 = (dateStr) => {
    if (!dateStr) return '';

    const parsedDate = new Date(dateStr);
    if (isNaN(parsedDate)) return '';

    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return parsedDate.toLocaleDateString('en-US', options);
};



export const formatToLocalDateTime = (date) => {
  const offset = date.getTimezoneOffset(); // Get the timezone offset in minutes
  const localDate = new Date(date.getTime() - offset * 60000); // Adjust to local time
  console.log('localDate',localDate);
  return localDate.toISOString().slice(0, 16); // Format as yyyy-MM-ddTHH:mm
}

export const formatToLocalDateTimeByNumber = (date) => {
  const offset = date.getTimezoneOffset(); // Get the timezone offset in minutes


  const localDate = new Date(date - offset * 60000); // Adjust to local time
  console.log('localDate',localDate);
  return  new Date(localDate+'Z').getTime()//localDate.toISOString().slice(0, 16); // Format as yyyy-MM-ddTHH:mm
}

export const getExactCurrentTime = (date) => { 
  date.setSeconds(0, 0); // Truncate seconds and milliseconds
  const offset = date.getTimezoneOffset(); // Get timezone offset
  
  const localDate = new Date(date.getTime() - offset * 60000); // Adjust to local time
  return localDate.toISOString().slice(0, 16); // Format as yyyy-MM-ddTHH:mm
}


export const getStoreApi = async (roleTitle) => {
    try
    {
      console.log("roleTitle",roleTitle);
      // let userStores;
      // const res2 = await APIGetUserLocations();
      // if (res2?.response) {
     
      //   userStores = res2?.response?.myStores.map((store) => ({
      //     // label: store.title,
      //     value: store._id,
      //     // storeCode: store.storeNumber,
      //   }));

      //   if(!userStores && roleTitle == "TenantAdmin")
      //   userStores = res2?.response?.dataAccessStores.map((store) => ({
      //     // label: store.title,
      //     value: store._id,
      //     // storeCode: store.storeNumber,
      //   }));
      // }
      const res = await APIgetStores({});
     
      if (res?.response?.stores) {
        const storeData = res.response.stores.reverse();
        localStorage.removeItem("allStores");
        localStorage.setItem(
          "allStores",
          JSON.stringify(storeData)
        );
          const storeOptions = storeData.map((store) => ({
          name: store.title, // storeNumber
          _id: store._id,
          storeCode: store.storeNumber, // Store code
        }));
        // const storeOptions1 = storeData.map((store) => ({
        //   name: store.title, // storeNumber
        //   _id: store._id,
        //   storeCode: store.storeNumber, // Store code
        // }));

        // const storeOptions = userStores?.length
        // ? storeOptions1.filter((store) =>
        //     userStores.some((userStore) => userStore.value === store._id)
        //   )
        // : storeOptions1;

        const storeOptionsList = (() =>
          [{ label: "All Stores", value: "" }].concat(
            storeOptions?.map((itm) => ({ label: itm.name, value: itm._id }))
          ))();
        localStorage.setItem(
          "storeOptionsList",
          JSON.stringify(storeOptionsList)
        );
        const storeCodes = storeOptions.map((itm) => itm.storeCode).join(",");
        localStorage.removeItem("storeIds");
        localStorage.removeItem("storeCodes");

        localStorage.setItem("storeCodes", storeCodes);
        const storeIds = storeOptions.map((itm) => itm._id).join(",");
        localStorage.setItem("storeIds", storeIds);
      }
    } catch (error) {
      console.error("SignIn Error", error);
      //setErrors({ general: "Invalid email or password" });
    }
  };

export const getCurrencySymbol = () => {
 if(localStorage.getItem("tenantId") == "n4Xc96g6qyNcrq5dD") 
 {
  return "$";
 }
 if(localStorage.getItem("tenantId") == "jNrhXAynhAbQkrj8Y") 
 {
  return "$";
 }
  if(localStorage.getItem("tenantId") == "8wNWEtTEdgoywriNX") 
 {
  return "$";
 }

 else
 {
  return "";
 }
}